(function () {
  const REVIEW_WIDGET_ID = 'judgeme_product_reviews';
  const MOBILE_BREAKPOINT = 551;

  function openReviewsTab() {
    const reviewWidget = document.getElementById(REVIEW_WIDGET_ID);
    if (!reviewWidget) return false;

    const tabContent = reviewWidget.closest('.tab-content');
    if (!tabContent) return false;

    const productTab = tabContent.closest('product-tab');
    if (!productTab) return false;

    const tabId = tabContent.id;
    if (!tabId) return false;

    const mobileId = tabId + '-mobile';
    const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

    if (isMobile) {
      const toggleLink = tabContent.querySelector('a.toggleLink[href="#' + mobileId + '"]');
      const toggleContent = document.getElementById(mobileId);

      if (!toggleLink || toggleLink.classList.contains('is-open')) return true;

      toggleLink.classList.add('is-open');
      if (toggleContent) toggleContent.style.display = 'block';
      return true;
    }

    const tabTitle = productTab.querySelector('a.tab-title[href="#' + tabId + '"]');

    if (tabTitle && !tabTitle.classList.contains('is-open')) {
      productTab.querySelectorAll('.tab-title.is-open').forEach(function (el) {
        el.classList.remove('is-open');
      });
      productTab.querySelectorAll('.tab-content.is-active').forEach(function (el) {
        el.classList.remove('is-active');
      });

      tabTitle.classList.add('is-open');
      tabContent.classList.add('is-active');

      const tabContents = productTab.querySelector('.tabs-contents');
      if (tabContents) tabContents.classList.add('is-show');
      return true;
    }

    if (!tabTitle) {
      const toggleLink = tabContent.querySelector('a.toggleLink[href="#' + mobileId + '"]');
      const toggleContent = document.getElementById(mobileId);

      if (toggleLink && !toggleLink.classList.contains('is-open')) {
        toggleLink.classList.add('is-open');
        if (toggleContent) toggleContent.style.display = 'block';
      }
    }

    return true;
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest('.jdgm-preview-badge')) return;
      openReviewsTab();
    },
    true
  );
})();
